import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

const defaultLang = 'en';

i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    lng: defaultLang,
    fallbackLng: defaultLang,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
